module.exports = __webpack_public_path__ + "5a698453f3b25b84d0bbf779b0206bf5.woff";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-semibold.woff
// module id = 79
// module chunks = 0